import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import TriggerNotificationsList from './TriggerNotificationsList';
import { Button, DropdownMenu, Tooltip } from '@cobliteam/ui/components';
import { usePrevious } from 'ahooks';

import { Analytics } from '@cobliteam/analytics';
import { endOfDay, startOfDay } from '@cobliteam/utils/date';

import { useGetUnreadNotificationsAmount } from '@cobliteam/hooks/src/useEntity/useAlerts';

import Icon from '@cobliteam/ui/icons';

const today = new Date();
const limitDay = new Date(new Date().setDate(today.getDate() - 10));

const NotificationsButton = () => {
  const location = useLocation();
  const prevLocation = usePrevious(location);

  const [open, setOpen] = useState(false);

  const startOfDayISO = startOfDay(limitDay).toISOString();
  const endOfDayISO = endOfDay(today).toISOString();
  const { data: unreadAmount, refetch } = useGetUnreadNotificationsAmount(startOfDayISO, endOfDayISO);
  const amountLabel = unreadAmount && unreadAmount < 10 ? unreadAmount.toString() : '9+';

  useEffect(() => {
    if (location !== prevLocation) {
      setOpen(false);
    }
  }, [location, prevLocation]);

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger>
        <Tooltip content='Notificações' asChild>
          <div className='relative'>
            <Button variant='outlined' color='secondary' size='condensed' icon={<Icon name='bell' />} onClick={() => Analytics.track('Navbar Notification Button Clicked')} />
            {unreadAmount ? <div className='-right-2 -top-1 absolute rounded-full bg-danger px-[5px] text-[10px] text-white'>{amountLabel}</div> : null}
          </div>
        </Tooltip>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content className='w-[500px] p-0' portal>
        <TriggerNotificationsList unreadNotifications={unreadAmount} onMarkAllAsRead={() => refetch()} />
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default NotificationsButton;
